<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="permissionsArray.includes('access_vendor_request_form')">
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">{{pageTitle}}</div>
                        <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                    </div>
                    <!--Forms-->
                    <div class="forms-container default-bx-shadow responsive-forms-container">
                        <div class="row no-margin">
                            <!-- Name -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <template v-if="edit_id == 0">
                                        <input @blur="checkNameExists()" type="text" maxlength="190" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="help is-danger">{{nameError}}</div>
                                        <div class="requiredstar">*</div>
                                    </template>
                                    <template v-else>
                                        <span class="form-control">{{name}}</span>
                                    </template>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                &nbsp;
                            </div>
                            <template v-for="(vendorItm, index) in vendorItemArr">
                                <div :key="'description ' + index" class="col-5 forms-block">
                                    <div class="">
                                        <div class="form-label">Description :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="vendorItm.descriptionError = ''" maxlength="190" class="form-control" v-model="vendorItm.description" id="description" name="description">
                                        <div class="help is-danger">{{vendorItm.descriptionError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                <div :key="'Unit of Measure Code ' + index" class="col-3 forms-block">
                                    <div class="">
                                        <div class="form-label">Unit of Measure Code :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" maxlength="190" class="form-control" v-model="vendorItm.unitMeasureCode" id="unitMeasureCode" name="unitMeasureCode">
                                        <!-- <input type="text" @input="vendorItm.unitMeasureCodeError = ''" maxlength="190" class="form-control" v-model="vendorItm.unitMeasureCode" id="unitMeasureCode" name="unitMeasureCode"> -->
                                        <!-- <div class="help is-danger">{{vendorItm.unitMeasureCodeError}}</div>
                                        <div class="requiredstar">*</div> -->
                                    </div>
                                </div>
                                <div :key="'Item No ' + index" class="col-3 forms-block">
                                    <div class="">
                                        <div class="form-label">Item No :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="vendorItm.itemNoError = ''" maxlength="190" class="form-control" v-model="vendorItm.itemNo" id="itemNo" name="itemNo">
                                        <div class="help is-danger">{{vendorItm.itemNoError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                <template v-if="vendorItemArr.length == (index + 1) && plusCountVendorItem != 0">
                                    <div :key="'plus ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="addNewDocumentVendor(vendorItm, index)" class="btn btn-success">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div :key="'close ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="removeVendorDocument(vendorItm, index)" class="btn btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </template>
                            <div class="clearfix"></div>
                            <div class="mr-17 pb-12 float-l">
                                <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                                <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addVendorItem('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                                <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addVendorItem('save')"><span id="createAttachment">Save</span></button>
                            </div>
                        </div>
                    </div>
                    <!-- Forms -->
                </div>
                <!--page content-->
            </div>
        </template>
        <template v-else>
            <no-access></no-access>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    import NoAccessPage from "@/components/NoAccessPage/NoAccessPage";
    var self;
    Vue.component('v-select', vSelect);
    Vue.component("app-footer", Footer);
    Vue.component('no-access', NoAccessPage);
    export default {
        name: 'AddUpdateVendor',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add Vendor',
                edit_id: 0,
                name: "",
                nameError: "",
                vendorItemArr: [
                    {
                        description: "",
                        descriptionError: "",
                        unitMeasureCode: "",
                        // unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                    },
                ],
                tempVendorItemObject: {
                    description: "",
                    descriptionError: "",
                    unitMeasureCode: "",
                    // unitMeasureCodeError: "",
                    itemNo: "",
                    itemNoError: "",
                },
                plusCountVendorItem: 99,
                loginUserRoleId: 1,
                isVendorNameExists: false,
                permissionsArray: ['access_vendor_request_form'],
            }
        },
        watch: {
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("ListVendor");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }
            this.$nextTick(function () {
                if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    self.isVendorNameExists = false,
                    self.edit_id = self.$route.params.id;
                    self.pageTitle = 'Edit Vendor';
                    self.getVendorById();
                    $("#createAttachment").html("Update");
                    self.hideLoader();
                }
            });
        },
        methods: {
            buttonBack() {
                self.$router.push('/vendor/item/list');
            },
            getVendorById() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        id: self.edit_id,
                    }
                };
                self.showLoader();
                HTTP.get("/vendor/byid/get", config)
                    .then(function (response) {
                        self.name = response.data.content.name;
                        if(response.data.content.mapper && response.data.content.mapper.length > 0)
                        {
                             self.vendorItemArr = response.data.content.mapper;
                            self.plusCountVendorItem -= (response.data.content.mapper.length - 1);
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            checkNameExists: function() {
                if(!self.name) {
                    return false;
                }
                if(self.edit_id != 0) {
                    return false;
                }
                self.isVendorNameExists = false;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                };
                var fields = {
                    name: self.name
                };
                HTTP.post("/vendor/check", fields, config)
                    .then(function (response) {
                        if (response.data.code == '201') {
                            self.isVendorNameExists = true;
                            self.showSAlert('Vendor Name already Exists', 'info');
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            removeVendorDocument: function(object, index) {
                if(self.plusCountVendorItem <= 99 ) {
                    self.plusCountVendorItem = self.plusCountVendorItem + 1;
                    self.vendorItemArr.splice(index, 1);
                }
            },
            addNewDocumentVendor: function(object, index) {
                var error = true;
                self.vendorItemArr[index].descriptionError = "";
                // self.vendorItemArr[index].unitMeasureCodeError = "";
                self.vendorItemArr[index].itemNoError = "";

                if(!self.vendorItemArr[index].description) {
                    self.vendorItemArr[index].descriptionError = "Enter Description";
                    if (error) {
                        error = false;
                    }
                }
               /*  if(!self.vendorItemArr[index].unitMeasureCode) {
                    self.vendorItemArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                    if (error) {
                        error = false;
                    }
                } */
                if(!self.vendorItemArr[index].itemNo) {
                    self.vendorItemArr[index].itemNoError = "Enter Item No";
                    if (error) {
                        error = false;
                    }
                }
                if(error) {
                    self.plusCountVendorItem = self.plusCountVendorItem - 1;
                    self.vendorItemArr.push(Vue.util.extend({}, self.tempVendorItemObject));
                }
            },
            checkForm: function () {
                var checked = true;
                var index = 0;
                self.nameError = "";
                self.vendorItemArr[index].descriptionError = "";
                // self.vendorItemArr[index].unitMeasureCodeError = "";
                self.vendorItemArr[index].itemNoError = "";

                if (!self.name) {
                    self.nameError = "Please enter name";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.vendorItemArr[index].description) {
                    self.vendorItemArr[index].descriptionError = "Enter Description";
                    if (checked) {
                        checked = false;
                    }
                }
                /* if(!self.vendorItemArr[index].unitMeasureCode) {
                    self.vendorItemArr[index].unitMeasureCodeError = "Enter Unit Measure Code";
                    if (checked) {
                        checked = false;
                    }
                } */
                if(!self.vendorItemArr[index].itemNo) {
                    self.vendorItemArr[index].itemNoError = "Enter Item No";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addVendorItem(flag) {
                if(self.isVendorNameExists) {
                    self.showSAlert('Vendor Name already Exists', 'info');
                    return false;
                }
                setTimeout(() => {
                    if (!self.isVendorNameExists && self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            id: self.edit_id,
                            name: self.name,
                            vendorItemArr: self.vendorItemArr,
                        };
                        self.showLoader();
                        HTTP.post("/vendor/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if (flag == 'save') {
                                        self.buttonBack();
                                    } else {                                        
                                        self.clearSaveAndContinue();
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            clearSaveAndContinue: function() {
                self.edit_id = 0;
                self.vendorItemArr = [];
                self.vendorItemArr = [
                    {
                        description: "",
                        descriptionError: "",
                        unitMeasureCode: "",
                        // unitMeasureCodeError: "",
                        itemNo: "",
                        itemNoError: "",
                    },
                ];
                self.plusCountVendorItem = 99;
                self.name = '';
                self.isVendorNameExists = false;
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            if(permissionArray && permissionArray.length > 0) {
                for (var i = 0; i < permissionArray.length; i++) {
                    self.permissionsArray.push(permissionArray[i].name);
                }
            }
        }
    });
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Forms/VendorMaster/AddUpdateVendor.vue